import { z } from "zod";

// Scalar wire shapes for the TOV spine. The trait and full Version responses
// live in definitions.responses.ts and version.responses.ts; this file keeps
// the public profile shapes.
// Timestamps are ISO-8601 strings; the backend converts raw UTC at the boundary.

export const TovProfileResponseSchema = z.object({
  id: z.uuid(),
  clientId: z.uuid(),
  name: z.string(),
  currentVersionId: z.uuid().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type TovProfileResponse = z.infer<typeof TovProfileResponseSchema>;

export const TovProfileListResponseSchema = z.object({
  profiles: z.array(TovProfileResponseSchema),
});
export type TovProfileListResponse = z.infer<
  typeof TovProfileListResponseSchema
>;
